import { Injectable } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ApplicationService,
  VehicleAppEntityVehicleRead,
  VehicleAppEntityVehicleWrite,
  VehicleService
} from '../openapi';
import { forkJoin, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VehicleCommonService {
  constructor(
    private vehicleService: VehicleService,
    private applicationService: ApplicationService
  ) {
  }

  public updateVehicles(
    currentApp: ApplicationAppEntityApplicationRead,
    payload: ApplicationAppEntityApplicationWrite,
    vehicles: VehicleAppEntityVehicleWrite[]
  ): Observable<ApplicationAppEntityApplicationRead> {
    const deleteRequests = currentApp?.vehicles?.map(v => this.vehicleService.deleteVehicleVehicleItem({ id: v?.uuid || '' }));
    return (deleteRequests?.length ? forkJoin(deleteRequests) : of([])).pipe(
      switchMap(() => {
        return (vehicles.length ? forkJoin(
          vehicles.map(vehicle => this.vehicleService.postVehicleVehicleCollection({ vehicle }))
        ) : of([])).pipe(
          switchMap((created: VehicleAppEntityVehicleRead[]) => this.applicationService.patchApplicationApplicationItem({
            id: currentApp?.uuid || '',
            application: { ...payload, vehicles: created.map(v => v?.uuid || '') || [] }
          }))
        );
      })
    );
  }
}
